import React, { useCallback, useEffect, useRef, useState } from "react";

import { useParams } from "react-router-dom";
import { Box, Tab, Tabs } from "@mui/material";

import LessonForm, {
  LessonFormRef,
  TLessonForm,
} from "@app/features/Lesson/view/Form";
import QuestionForm from "@app/features/Question/view/Form";

import { useLessonRepository } from "@app/features/Lesson/data/lessonRepository";
import { useEditLessonViewModel } from "@app/features/Lesson/view/Edit/editLessonViewModel";

import lessonService from "@app/services/lesson";

import LoadingLock from "@app/components/molecules/LoadingLock";
import FooterActions from "@app/components/molecules/FooterActions";
import StandardTemplate from "@app/components/templates/Standard";
import TabPanel from "@app/components/templates/TabPanel";
import Drawer, { IDrawerRef } from "@app/components/molecules/Drawer";
import CreateTag from "@app/features/Tag/views/Create";

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const EditLesson = () => {
  const drawerTagRef = useRef<IDrawerRef>();
  const lessonFormRef = useRef<LessonFormRef>();

  const { id } = useParams();

  const [currentTab, setCurrentTab] = useState(0);

  const lessonRepository = useLessonRepository(lessonService);
  const { getLesson, editLesson, isLoading, lesson, questions } =
    useEditLessonViewModel(lessonRepository);

  const handleChangeCurrentTab = useCallback(
    (event: React.SyntheticEvent<Element, Event>, value: number) => {
      setCurrentTab(value);
    },
    []
  );

  const handleSaveLesson = useCallback(
    (data: TLessonForm) => {
      editLesson({
        ...data,
        id: Number(id),
      });
    },
    [id, editLesson]
  );

  const handleOpenDrawerTag = useCallback(() => {
    drawerTagRef.current?.openDrawer();
  }, []);

  const handleCloseDrawerTag = useCallback(() => {
    drawerTagRef.current?.closeDrawer();
    lessonFormRef.current?.getTags();
  }, []);

  useEffect(() => {
    getLesson(Number(id));
  }, [getLesson, id]);

  return (
    <StandardTemplate title="Editar Aula" showBackButton>
      <LoadingLock isLoading={isLoading} />
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={currentTab}
          onChange={handleChangeCurrentTab}
          aria-label="basic tabs example"
        >
          <Tab label="Dados da aula" {...a11yProps(0)} />
          <Tab label="Perguntas" {...a11yProps(1)} />
        </Tabs>

        <TabPanel value={currentTab} index={0}>
          <LessonForm
            dataForm={lesson}
            onClickOpenDrawerTags={handleOpenDrawerTag}
            onValidateSuccess={handleSaveLesson}
            footerActions={<FooterActions />}
          />
        </TabPanel>
        <TabPanel value={currentTab} index={1}>
          <QuestionForm
            edit
            pageId={Number(id)}
            dataForm={{ questions }}
            onValidateSuccess={() => null}
          />
        </TabPanel>
      </Box>
      <Drawer ref={drawerTagRef} drawerPosition="bottom">
        <Box sx={{ p: 4 }}>
          <CreateTag onFinish={handleCloseDrawerTag} />
        </Box>
      </Drawer>
    </StandardTemplate>
  );
};

export default EditLesson;
